import { createAction } from '@reduxjs/toolkit';
export const createSpaceSagaAction = createAction('spaces/createSpaceSagaAction');
export const fetchSpaceDetailSagaAction = createAction('spaces/fetchSpaceDetailSagaAction');
export const deleteSpaceSagaAction = createAction('spaces/deleteSpaceSagaAction');
export const editSpaceSagaAction = createAction('spaces/editSpaceSagaAction');
